import { useContext } from 'react'
import { Page, Container, LogoContainer, ContentContainer, Title, Paragraph } from '@/styles/page.styles'
import svgs from '@/constants/svgs'

import { StoreContext } from '@/components/App'
import { observer } from 'mobx-react'

export const SuccessPage = observer(() => {
  const store = useContext(StoreContext)
  const { theme, themeId } = store.AppState

  return (
    <Page {...theme.app}>
      <Container {...theme.container}>
        {theme.infoPage.$showAboveTitle && (
          <LogoContainer>
            {theme.logo.$svg && (
              <div>
                <img src={theme.logo.$svg} />
              </div>
            )}
            {svgs[themeId].success ? (
              <div>
                <img src={svgs[themeId].success} />
              </div>
            ) : (
              <div className={'empty'} />
            )}
          </LogoContainer>
        )}

        <ContentContainer {...theme.container}>
          <Title {...theme.title}>Success!</Title>
          {svgs[themeId].success && !theme.infoPage.$showAboveTitle && (
            <LogoContainer>
              <img src={svgs[themeId].success} />
            </LogoContainer>
          )}
          <Paragraph {...theme.paragraph}>Your password has been changed successfully!</Paragraph>
        </ContentContainer>
      </Container>
    </Page>
  )
})
